import SingleColumnTemplate from '@/components/layouts/SingleColumnTemplate';
import Jumbotron from '@/components/ui/box/Jumbotron';
import Panel from '@/components/ui/box/Panel';
import Paper from '@/components/ui/box/Paper';

import styles from './SingleCardTemplate.module.scss';

interface Props {
  title: string;
  children?: React.ReactNode;
}

const SingleCardTemplate: React.FC<Props> = ({ title, children }) => (
  <SingleColumnTemplate>
    <div className={styles.wrapper}>
      <Jumbotron>
        <Paper>
          <Panel title={title} strongHeader>
            {children}
          </Panel>
        </Paper>
      </Jumbotron>
    </div>
  </SingleColumnTemplate>
);

export default SingleCardTemplate;
